module.exports = __webpack_public_path__ + "static/media/logo192.b8eee77f.png";